/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UnlinkSkillRequestBody,
  UnlinkSkillRequestBody$Outbound,
  UnlinkSkillRequestBody$outboundSchema,
} from "../components/unlinkskillrequestbody.js";

export type UnlinkSkillSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UnlinkSkillSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UnlinkSkillSecurity = {
  option1?: UnlinkSkillSecurityOption1 | undefined;
  option2?: UnlinkSkillSecurityOption2 | undefined;
};

export type UnlinkSkillRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  unlinkSkillRequestBody: UnlinkSkillRequestBody;
};

/** @internal */
export type UnlinkSkillSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UnlinkSkillSecurityOption1$outboundSchema: z.ZodMiniType<
  UnlinkSkillSecurityOption1$Outbound,
  UnlinkSkillSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function unlinkSkillSecurityOption1ToJSON(
  unlinkSkillSecurityOption1: UnlinkSkillSecurityOption1,
): string {
  return JSON.stringify(
    UnlinkSkillSecurityOption1$outboundSchema.parse(unlinkSkillSecurityOption1),
  );
}

/** @internal */
export type UnlinkSkillSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UnlinkSkillSecurityOption2$outboundSchema: z.ZodMiniType<
  UnlinkSkillSecurityOption2$Outbound,
  UnlinkSkillSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function unlinkSkillSecurityOption2ToJSON(
  unlinkSkillSecurityOption2: UnlinkSkillSecurityOption2,
): string {
  return JSON.stringify(
    UnlinkSkillSecurityOption2$outboundSchema.parse(unlinkSkillSecurityOption2),
  );
}

/** @internal */
export type UnlinkSkillSecurity$Outbound = {
  Option1?: UnlinkSkillSecurityOption1$Outbound | undefined;
  Option2?: UnlinkSkillSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UnlinkSkillSecurity$outboundSchema: z.ZodMiniType<
  UnlinkSkillSecurity$Outbound,
  UnlinkSkillSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UnlinkSkillSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UnlinkSkillSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function unlinkSkillSecurityToJSON(
  unlinkSkillSecurity: UnlinkSkillSecurity,
): string {
  return JSON.stringify(
    UnlinkSkillSecurity$outboundSchema.parse(unlinkSkillSecurity),
  );
}

/** @internal */
export type UnlinkSkillRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UnlinkSkillRequestBody: UnlinkSkillRequestBody$Outbound;
};

/** @internal */
export const UnlinkSkillRequest$outboundSchema: z.ZodMiniType<
  UnlinkSkillRequest$Outbound,
  UnlinkSkillRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    unlinkSkillRequestBody: UnlinkSkillRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      unlinkSkillRequestBody: "UnlinkSkillRequestBody",
    });
  }),
);

export function unlinkSkillRequestToJSON(
  unlinkSkillRequest: UnlinkSkillRequest,
): string {
  return JSON.stringify(
    UnlinkSkillRequest$outboundSchema.parse(unlinkSkillRequest),
  );
}
